module.exports = __webpack_public_path__ + "static/media/Ram@2x.0a91fc74.png";